// extracted by mini-css-extract-plugin
module.exports = {"root":"TxAddonForm_root__9V31s","generalInput":"TxAddonForm_generalInput__2eG3v"};